import { Box, Stack } from '@mui/material';

import { url } from '../../../appRouter/url';
import {
  ablaufEndColumn,
  ablaufStartColumn,
  expertsColumn,
  Link,
  statusColumn,
  ThemaCard,
  TrpcLoadingInfo,
  veranstaltungSapIdColumn,
} from '../../../components/general';
import { veranstaltungWoColumn } from '../../../components/general/TableColumns';
import { type ThemaFromSearchRouter } from '../../../dtos';
import { trpc } from '../../../trpc';
import { type DataGridColDef } from '../../../utils';

type ThemaSearchProps = {
  readonly searchTerm: string;
};

const themaSearchColumns = (): DataGridColDef<ThemaFromSearchRouter['veranstaltungen'][number]> => {
  const columns: DataGridColDef<ThemaFromSearchRouter['veranstaltungen'][number]> = [
    ablaufStartColumn(), //
    ablaufEndColumn(),
    veranstaltungSapIdColumn(),
    statusColumn(),
    veranstaltungWoColumn(),
    expertsColumn(),
  ];

  return columns;
};

export const ThemaSearch = ({ searchTerm }: ThemaSearchProps) => {
  const themen = trpc.search.searchThema.useQuery({ searchTerm }, { enabled: searchTerm.length > 0 });

  return (
    <Box sx={{ marginLeft: 4, paddingRight: 4 }}>
      <Stack direction="column" spacing={5}>
        <TrpcLoadingInfo trpcQuery={themen} entity="Themen">
          {themen.data?.map((thema) => (
            <ThemaCard
              key={thema.veranstaltungstypSapId}
              thema={thema}
              columns={themaSearchColumns()}
              getRowId={(veranstaltung) => veranstaltung.akaVeranstaltungId}
            >
              <Link url={url.thema.details(thema.akaThemaId)}>Zum Thema</Link>
            </ThemaCard>
          ))}
        </TrpcLoadingInfo>
      </Stack>
    </Box>
  );
};
